
  import { Component, Vue } from 'vue-property-decorator'
  import CreateMeeting from '../../components/mettings/CreateMeeting.vue'

  @Component({ components: { CreateMeeting } })
  export default class MettingForm extends Vue {}
